import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UpdateScore = ({ data, open, close, successMsg }) => {
  const [formData, setFormData] = useState({
    score: data ? data.score : "",
    user_id: data ? data.user_id : "",
    admin_id: sessionStorage.getItem("admin_id"),
    updated_at: moment().format("YYYY-MM-DD HH:mm:ss")
  });

  const handleScoreChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      setFormData(prev => ({ ...prev, score: "" }));
      return;
    }

    // Check if input is a number and within range
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      setFormData(prev => ({
        ...prev,
        score: value
      }));
    } else {
      toast.error("Please enter a number ", {
        position: "top-center",
        autoClose: 2000
      });
    }
  };

  const handleSubmit = () => {
    const scoreNum = parseFloat(formData.score);

    if (formData.score === "" || isNaN(scoreNum)) {
      toast.warn("Please enter a score before submitting!", { position: "top-right" });
      return;
    }

   

    axios
      .put(
        `https://batak-pro-server.xicsolutions.in/score/updateUserScore/${data.score_id}`,
        formData
      )
      .then(() => {
        toast.success("Successfully updated score", { autoClose: 3000 });
        setTimeout(() => {
          successMsg();
          close();
        }, 3000);
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message, { autoClose: 3000 });
        } else {
          toast.error("Error updating score", { autoClose: 3000 });
        }
        console.error("Error updating score:", err);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: "20px",
          padding: "20px",
          background: " rgba(12, 12, 12, 0.27)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgb(255, 255, 255)",
        },
      }}
    >
      <DialogTitle
        style={{
          textAlign: 'center',
          color: 'white',
          fontWeight: 'bold',
          letterSpacing: '1px',
          fontSize: '24px',
          borderRadius: '10px',
          padding: '15px'
        }}
      >
        Update Score
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            textAlign: 'center',
            marginBottom: '20px',
            fontSize: '18px',
            fontWeight: 'bold',
            color: 'white',
            padding: '10px',
            borderRadius: '10px'
          }}
        >
          Current Score: {data.score || "Not available"}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
          <div style={{ fontSize: '20px', color: 'white' }}>
            Enter new score 
          </div>
          <input
            type="text"
            value={formData.score}
            onChange={handleScoreChange}
            placeholder="Enter Score"
            style={{
              width: '130px',
              height: '50px',
              padding: '8px 16px',
              fontSize: '1.1rem',
              border: '1px solid rgb(255, 255, 255)',
              borderRadius: '20px',
              outline: 'none',
              textAlign: 'center',
              background: 'rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(5px)',
              color: 'white',
              transition: 'all 0.3s ease',
            }}
          />
        </div>
      </DialogContent>
      <DialogActions
        style={{
          justifyContent: 'center',
          gap: "1rem",
          padding: '20px',
          borderRadius: '10px',
          margin: '20px 0 0 0'
        }}
      >
        <Button
          onClick={close}
          variant="outlined"
          style={cancelButtonStyle}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          style={submitButtonStyle}
        >
          Submit
        </Button>
      </DialogActions>
      <ToastContainer />
    </Dialog>
  );
};

const cancelButtonStyle = {
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  color: "white",
  borderRadius: "20px",
  padding: "10px 20px",
  fontWeight: "bold",
  border: "1px solid white",
  backdropFilter: "blur(5px)",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
  }
};

const submitButtonStyle = {
  backgroundColor: "rgba(96, 0, 210, 0.8)",
  color: "#fff",
  borderRadius: "20px",
  padding: "10px 20px",
  fontWeight: "bold",
  backdropFilter: "blur(5px)",
  border: "1px solid white",
  transition: "all 0.3s ease",
  
};

export default UpdateScore;